package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class LoginRequest(
    val email: String,
    val password: String
)

@Serializable
data class RegisterRequest(
    val email: String,
    val username: String,
    val password: String,
    val firstName: String?,
    val lastName: String?,
    val phone: String?,
    val avatarDataUrl: String? = null,
    val language: String? = null,
    val legalAccepted: Boolean = false,
    val acceptedVersions: Map<String, String>? = null
)

@Serializable
data class AuthResponse(
    val token: String,
    val refreshToken: String? = null,
    val type: String = "Bearer",
    val userId: Long,
    val email: String,
    val username: String
)

@Serializable
data class AuthError(
    val error: String
)

@Serializable
data class UpdateProfileRequest(
    val username: String,
    val firstName: String? = null,
    val lastName: String? = null,
    val phone: String? = null,
    val avatarDataUrl: String? = null,
    val language: String? = null
)

@Serializable
data class PasswordResetRequest(
    val email: String
)

@Serializable
data class PasswordResetConfirmRequest(
    val token: String,
    val newPassword: String
)

@Serializable
data class PasswordResetTokenStatus(
    val valid: Boolean
)

@Serializable
data class DeleteAccountRequest(
    val userId: Long
)
